<template>
    <transition name="fade">
        <div
            class="robot-backdrop flex justify-center items-center absolute w-full h-full d-flex justify-content-center align-items-center position-absolute w-100 h-100"
        >
            <div class="robot-box position-relative">
                <div class="robot">
                    <div class="head-box">
                        <div class="thinking">
                            <div></div>
                            <div></div>
                        </div>
                        <div class="head">
                            <div class="face">
                                <div class="eyes eye-left"></div>
                                <div class="eyes eye-right"></div>
                            </div>
                        </div>
                    </div>

                    <div class="body">
                        <div class="torso"></div>
                        <div class="arms arm-left"></div>
                        <div class="arms arm-right"></div>
                    </div>
                </div>
                <div class="robot-shadow"></div>
                <div v-if="showProgressBar" class="robot-progress flex d-flex">
                    <div v-for="(box, index) in +totalProgress" :key="index" class="flex-1">
                        <div
                            :style="[
                                errorProgress.find(e => e === box) ? { 'background-color': '#dc3545' } : {},
                                +progress >= +box ? { width: '100%' } : { width: '0%' }
                            ]"
                            class="progress"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        showProgressBar: {
            type: Boolean,
            default: false
        },

        progress: {
            type: [String, Number],
            default: 0
        },

        totalProgress: {
            type: [String, Number],
            default: 0
        },

        errorProgress: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style lang="scss">
.robot-backdrop {
    background-color: rgba(157, 157, 157, 0.7);
    z-index: 9999;

    .robot-box {
        transform: scale(0.5);
        .robot {
            position: relative;
            animation: robot-animation 1s infinite alternate;

            .head-box {
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                width: 150px;
                height: 120px;

                .thinking {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                    aspect-ratio: 1 / 1;

                    > div {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 100%;
                        height: 100%;
                        transform: translate(-50%, -50%);
                        border-radius: 50%;

                        &:first-child {
                            background-color: rgba(255, 255, 255, 0.2);
                            animation: thinking-animation-back 1s infinite alternate;
                        }

                        &:nth-child(2) {
                            background-color: rgba(255, 255, 255, 0.5);
                            animation: thinking-animation-front 1s infinite alternate;
                        }
                    }
                }

                .head {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 200px 200px 120px 120px;
                    background-color: #fff;

                    .face {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 75%;
                        height: 75%;
                        border-radius: 200px 200px 120px 120px;
                        background-color: #000;

                        .eyes {
                            position: absolute;
                            top: 24px;
                            width: 30px;
                            height: 20px;
                            border-radius: 60%;
                            background-color: #007bd9;

                            &.eyes.eye-left {
                                left: 20px;
                                transform: rotate(20deg);
                                animation: eyes-left-animation 1s infinite alternate;
                            }

                            &.eye-right {
                                right: 20px;
                                transform: rotate(-20deg);
                                animation: eyes-right-animation 1s infinite alternate;
                            }
                        }
                    }
                }
            }

            .body {
                position: relative;
                top: 8px;
                left: 50%;
                transform: translateX(-50%);

                .torso {
                    width: 154px;
                    aspect-ratio: 1 / 1.25;
                    border-radius: 40px 40px 80px 80px;
                    background-color: #fff;
                }

                .arms {
                    position: absolute;
                    top: 0;
                    width: 25px;
                    aspect-ratio: 1 / 5;
                    border-radius: 60%;
                    background-color: #fff;

                    &.arm-left {
                        left: -45px;
                        transform: rotateZ(20deg);
                        animation: arm-left-animation 1s infinite alternate;
                    }

                    &.arm-right {
                        right: -45px;
                        transform: rotateZ(-20deg);
                        animation: arm-right-animation 1s infinite alternate;
                    }
                }
            }
        }

        .robot-shadow {
            position: relative;
            top: 40px;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            height: 10px;
            border-radius: 50%;
            background: #000;
            animation: shadow-animation 1s infinite alternate;
        }

        .robot-progress {
            position: relative;
            top: 70px;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            height: 20px;
            border-radius: 12px;
            overflow: hidden;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 4px solid #fff;
                border-radius: 12px;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
            }

            .progress {
                height: 100%;
                background-color: #007bd9;
                transition: width 0.3s;
            }
        }

        @keyframes robot-animation {
            0% {
                transform: translateY(0%);
            }

            100% {
                transform: translateY(6%);
            }
        }

        @keyframes thinking-animation-back {
            0% {
                transform: translate(-50%, -50%) scale(0);
            }
            100% {
                transform: translate(-50%, -50%) scale(1.8);
            }
        }

        @keyframes thinking-animation-front {
            0% {
                transform: translate(-50%, -50%) scale(0);
            }
            100% {
                transform: translate(-50%, -50%) scale(1.2);
            }
        }

        @keyframes eyes-left-animation {
            0% {
                transform: rotate(20deg) scaleY(1);
            }
            100% {
                transform: rotate(20deg) scaleY(0.4);
            }
        }

        @keyframes eyes-right-animation {
            0% {
                transform: rotate(-20deg) scaleY(1);
            }
            100% {
                transform: rotate(-20deg) scaleY(0.4);
            }
        }

        @keyframes arm-left-animation {
            0% {
                transform: rotateZ(20deg);
            }

            100% {
                transform: rotateZ(16deg) translate(-50%, -70%);
            }
        }

        @keyframes arm-right-animation {
            0% {
                transform: rotateZ(-20deg);
            }

            100% {
                transform: rotateZ(-16deg) translate(50%, -70%);
            }
        }

        @keyframes shadow-animation {
            0% {
                opacity: 0.3;
                transform: translateX(-50%) scale(1);
            }

            100% {
                opacity: 1;
                transform: translateX(-50%) scale(1.4);
            }
        }
    }
}
</style>